export const casePlaceholderPrefix = "placeholder-";
